module.exports = __webpack_public_path__ + "img/cardImg01.2d4885d9.jpg";